import React, { Component } from 'react'

class NotFound extends Component {
  render() {
    return (
      <p>The page you requested could not be found</p>
    )
  }
}

export default NotFound
